import * as React from 'react';
import styled, { css } from 'styled-components';
import { Icon, Text, themeGet } from '@packages/ui';

const ICON_SIZE = 34;

const textStyle = css`
  flex: 0 1 385px;
`;

const iconStyle = css`
  margin-right: ${themeGet.space(3)};
` as any;

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 ${themeGet.space(3)};
`;

export interface NewsletterFooterSubmitMessageProps {
  submitMessage: string;
}

export const NewsletterFooterSubmitMessage: React.FC<NewsletterFooterSubmitMessageProps> = ({ submitMessage }) => {
  return (
    <Container>
      <Icon name="newsletter" size={ICON_SIZE} customCss={iconStyle} />
      <Text tag="span" fontSize={6} customCss={textStyle}>
        {submitMessage}
      </Text>
    </Container>
  );
};
